var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPromptActiveLocal ? true : false)?_c('div',[_vm._v("questions")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }